const searchActions = ({ setState }) => ({
  setSearchSuggestion(state, suggestion) {
    setState({...suggestion});
  },
  setIsFetching(state, isFetching) {
    setState({isFetching})
  },
  setIsSuggestionFetching(state, isSuggestionFetching) {
    setState({isSuggestionFetching})
  },
  setQuery(state, suggestionQuery) {
    setState({suggestionQuery})
  }
});

export default searchActions;

